import React, { useRef } from 'react';

// Pódio de ranking — Home (04/08/2026, pedido do Juan, "pensa comigo" +
// aprovado depois de comparar 2 propostas de layout e um ajuste de
// tamanho). Usado na Home (o 5S; o da Melhoria Contínua saiu com a Sala 34 antiga),
// mesmo componente pros dois — só muda título/período/dados/sufixo.
//
// `dados` já vem ORDENADO DESC do backend (top 3), cada item
// {setor_id, setor_nome, valor}. Lida com 1, 2 ou 3 itens (nem toda
// sala vai ter 3 setores com pontuação nos últimos 3 meses ainda) —
// com 0 itens, quem chama nem deve renderizar (mesmo padrão dos
// outros widgets da Home, `.length > 0` por fora).
//
// Confete (achado/ajuste do Juan): sai das duas pontas de baixo,
// diagonal pra dentro e pra cima, cruzando por trás do 1º lugar —
// dispara uma vez só ao entrar o mouse em QUALQUER parte do pódio
// (não por card individual), reseta ao sair.
const CORES_CONFETE = ['var(--ext)', '#EFB347', '#B85D22'];

function dispararConfete(podioEl) {
  const w = podioEl.clientWidth, h = podioEl.clientHeight;
  for (let i = 0; i < 24; i++) {
    const daEsquerda = i % 2 === 0;
    const el = document.createElement('div');
    el.className = 'pd-confete';
    const oy = h - 6 - Math.random() * 12;
    const ox = daEsquerda ? (16 + Math.random() * 14) : (w - 30 - Math.random() * 14);
    el.style.left = ox + 'px';
    el.style.top = oy + 'px';
    el.style.background = CORES_CONFETE[Math.floor(Math.random() * CORES_CONFETE.length)];
    const dx = daEsquerda ? (55 + Math.random() * 55) : -(55 + Math.random() * 55);
    const dy = -(60 + Math.random() * 55);
    el.style.setProperty('--dx', dx + 'px');
    el.style.setProperty('--dy', dy + 'px');
    el.style.animationDelay = (Math.random() * 0.12) + 's';
    podioEl.appendChild(el);
    setTimeout(() => el.remove(), 1100);
  }
}

const IconeTrofeu = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" style={{ margin: '0 auto', display: 'block' }}>
    <path d="M8 21h8M12 17v4M6 4h12l-1 8a5 5 0 01-10 0z" /><path d="M6 5H3v2a4 4 0 004 4M18 5h3v2a4 4 0 01-4 4" />
  </svg>
);
const IconeMedalha = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.09" style={{ margin: '0 auto', display: 'block' }}>
    <circle cx="12" cy="8" r="5" /><path d="M9 13l-2 8 5-3 5 3-2-8" />
  </svg>
);

function CardPosicao({ item, posicao, sufixo }) {
  const classe = posicao === 1 ? 'ouro' : posicao === 2 ? 'prata' : 'bronze';
  return (
    <div className={`pd-card ${classe}`}>
      {posicao === 1 ? <IconeTrofeu /> : <IconeMedalha />}
      <div className="pd-nome">{item.setor_nome}</div>
      <div className="pd-barra"><span className="pd-valor">{item.valor}{sufixo}</span></div>
      <div className="pd-posicao">{posicao}º lugar</div>
    </div>
  );
}

export default function PodioRanking({ titulo, periodo, dados, sufixo = '' }) {
  const podioRef = useRef(null);
  const disparadoRef = useRef(false);

  if (!dados || dados.length === 0) return null;

  const [primeiro, segundo, terceiro] = dados;

  const aoEntrar = () => {
    if (disparadoRef.current || !podioRef.current) return;
    disparadoRef.current = true;
    dispararConfete(podioRef.current);
  };
  const aoSair = () => { disparadoRef.current = false; };

  return (
    <div>
      <div style={{ fontSize: 'var(--txt-13)', fontWeight: 500, marginBottom: 1 }}>{titulo}</div>
      <div style={{ fontSize: 'var(--txt-11)', fontWeight: 500, color: 'var(--text-secondary)', marginBottom: 16 }}>{periodo}</div>
      <div className="pd-podium" ref={podioRef} onMouseEnter={aoEntrar} onMouseLeave={aoSair}>
        {segundo && <CardPosicao item={segundo} posicao={2} sufixo={sufixo} />}
        <CardPosicao item={primeiro} posicao={1} sufixo={sufixo} />
        {terceiro && <CardPosicao item={terceiro} posicao={3} sufixo={sufixo} />}
      </div>
    </div>
  );
}
